export default {
    PAGE_DASHBOARD: '/',
    PAGE_LOGIN: '/login',
    PAGE_CATEGORIES: '/categories',
    PAGE_PRODUCTS: '/products',
    PAGE_ORDERS: '/orders',
    PAGE_BLOGS: '/blogs',
    PAGE_USERS: '/users',
};
